/**
 * Responsive Breakpoints & Grid Configuration
 *
 * CRITICAL: These values MUST stay in sync with CSS:
 * - frontend/src/styles/tokens/breakpoints.css
 * - frontend/src/styles/layouts/responsive.css
 *
 * If CSS heights change, update this config immediately.
 */

export const BREAKPOINTS = {
  mobile: 320,
  tablet: 768,
  desktop: 1024,
  wide: 1440,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

export const GRID_CONFIG = {
  mobile: { columns: 1, itemHeight: 360, gap: 16 },
  tablet: { columns: 2, itemHeight: 320, gap: 16 },
  desktop: { columns: 3, itemHeight: 280, gap: 16 },
  wide: { columns: 4, itemHeight: 280, gap: 16 },
} as const;

export type GridConfig = (typeof GRID_CONFIG)[Breakpoint];

export function getBreakpoint(width: number): Breakpoint {
  if (width >= BREAKPOINTS.wide) return 'wide';
  if (width >= BREAKPOINTS.desktop) return 'desktop';
  if (width >= BREAKPOINTS.tablet) return 'tablet';
  return 'mobile';
}

export function getGridConfig(width: number): GridConfig {
  return GRID_CONFIG[getBreakpoint(width)];
}
